module.exports = __webpack_public_path__ + "img/jkx.e9eaf578.svg";